import { Component, Inject } from '@angular/core';
import { IonicPage, NavController, LoadingController } from 'ionic-angular';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { HttpParams,  HttpClient } from '@angular/common/http';
import { TimesheetlistPage } from '../../pages/timesheetlist/timesheetlist';
import { ForgotPasswordPage } from '../../pages/forgot-password/forgot-password';
import { GlobalProvider } from '../../providers/global/global';
import { ToastController } from 'ionic-angular';


/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {


  emailVisability: boolean = false;
  passVisability: boolean = false;
  formgroup: FormGroup;
  email: AbstractControl;
  pass: AbstractControl;
  requestData: Array<any>;
  url: string;
  splitted: string;
  portal: string;
  res: any;
  landingPage: any;
  page: string;
  data: any;
  url1: string;
  logoName: string;
  modifiedURL: string;

  url_img:string;
  modifiedURL_img: string;
  logoName_img: string;
  imgSrc: string;

  btnColor: string;

  logoWidth: string;
  logoHeight: string;
  agencyID : string;
  //agency_arr: any;


  isGUID: boolean = false;
  login_disable: boolean = false;
  constructor(public global: GlobalProvider, public http: HttpClient ,public navCtrl: NavController,
     public formbuilder: FormBuilder, @Inject(DOCUMENT) private document: Document,
      public loadingCtrl: LoadingController, private toastCtrl: ToastController)
   {
    
    this.login_disable = false;
    
    this.formgroup = formbuilder.group({
      email: ['', Validators.compose([Validators.maxLength(70), Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'), Validators.required])],
      pass: ['', Validators.compose([Validators.minLength(6), Validators.required])]
    });

    this.email = this.formgroup.controls['email'];
    this.pass = this.formgroup.controls['pass'];

    this.portal = this.global.getPortalID();

    for ( var i = 0; i < this.global.agency_arr.length; i++ ) {
      if (this.portal.includes(this.global.agency_arr[i].agencyName)  ) {
        this.btnColor = this.global.agency_arr[i].btnColor;
        this.logoWidth = this.global.agency_arr[i].width;
        this.logoHeight = this.global.agency_arr[i].height;
        this.agencyID = this.global.agency_arr[i].agencyID;
        break;
      }
    }
    this.imgSrc = '/assets/imgs/' + this.agencyID + '.png';


    //if logged in before
   

    // var uu = "?TTG2GUID=9A25E0F4-7BA4-4C1E-A1EB-24B15587B780"
    // var uu = ""
    // if(uu.includes("?TTG2GUID")){
    //   this.login_TTG2GUID();
    // }

    // Login through GUID
    // debugger
    // var storage_auth = localStorage.getItem('Auth');
    // var storage_agencyid = localStorage.getItem('agencyid');
    // // debugger
    // if (storage_auth != null && storage_agencyid == this.agencyID) {  
    //   if(window.location.search.includes("?TTG2GUID")){
    //     window.location.href = " ";
    //     // this.login_TTG2GUID();
    //   } else {
    //     this.navCtrl.setRoot(TimesheetlistPage);
    //   }
    // } else {
      
    // }

    var storage_auth = localStorage.getItem('Auth');
    var storage_agencyid = localStorage.getItem('agencyid');
    var storage_contactid = localStorage.getItem('ContactId');
    var storage_guid = localStorage.getItem('guid');

    
    //debugger
    if (storage_auth != null && storage_agencyid == this.agencyID && storage_contactid != null) { 
      
      //logged in before and has not logged out
      if ( window.location.search.includes("?TTG2GUID")){
        
        //if link has guid - check if it's the same as logged in guid
        var queryDict = {}
        var uu = window.location.search;
        uu.substr(1).split("&").forEach(function(item) { queryDict[item.split("=")[0]] = item.split("=")[1]})
        var GUID = queryDict['TTG2GUID'];
     
        // if(storage_guid != GUID){
          
          this.isGUID = true;
          this.login_TTG2GUID();

        // } else {

        //   //this.navCtrl.push(TimesheetlistPage);
        //   this.goToTimesheet('Timesheets');
        // } 
      } else {

        this.goToTimesheet('Timesheets');
      }
    } else if ( window.location.search.includes("?TTG2GUID")) {

      this.isGUID = true;
      this.login_TTG2GUID();
    } 

    // if ( window.location.search.includes("?TTG2GUID")){
    //   this.isGUID = true;
    //   this.login_TTG2GUID();
    // }

  }

  login_TTG2GUID(){
    
    var queryDict = {}
    var uu = window.location.search;
    uu.substr(1).split("&").forEach(function(item) { queryDict[item.split("=")[0]] = item.split("=")[1]})
    var GUID = queryDict['TTG2GUID'];
    var Source = queryDict['Source'] ? queryDict['Source'] : "";  
    localStorage.setItem('guid', GUID);
    localStorage.setItem('source', Source);
    this.httpRequest("","", GUID, Source);
  }

  login(){

    if (this.formgroup.valid) {

      this.emailVisability = false;
      this.passVisability = false;

      this.httpRequest(this.email.value, this.pass.value, "");
    }
    else {
      if(this.email.hasError('required') || this.email.hasError('pattern') ||this.email.hasError('maxlength'))
      {
        this.emailVisability = true;
      }
      else {
        this.emailVisability = false;
      }

      if(this.pass.hasError('required') || this.pass.hasError('minlength'))
      {
        this.passVisability = true;
      }
      else {
        this.passVisability = false;
      }
    }
  }


  httpRequest(email: string, password: string, guid: string, source: string = ""){
    // debugger
    this.login_disable = true;
    var p:any = {};
    //p.sp_name = "sp_login";
    p.username = email;
    p.password = password;
    p.guid = guid;
    p.portal = this.global.getPortalID();
    p.source = source;
    
    localStorage.setItem('username', this.email.value);
    //localStorage.setItem('password', this.pass.value);
    

    const params = new HttpParams().set('j',JSON.stringify(p))

    this.http.post('login/login_get/', params)
    .subscribe(data =>
    {

      this.res = data;
      this.data= JSON.parse(this.res.dt);
      //console.log(this.data);
      if(this.res.result == true){

      this.page = this.data[0]['LandingPage'];
      //console.log(this.page);
      this.landingPage = this.page.split('.')[0];
      //console.log(this.landingPage);
      //var ColourBanner1 = this.data[0]['ColourBanner1'];
      this.global.ColourBanner1 = this.data[0]['ColourBanner1'];
      this.global.ColourBanner2 = this.data[0]['ColourBanner2'];
      this.global.ColourDeSelected = this.data[0]['ColourDeSelected'];
      this.global.ColourFont = this.data[0]['ColourFont'];
      this.global.ColourFont1 = this.data[0]['ColourFont1'];
      this.global.ColourFont2 = this.data[0]['ColourFont2'];
      this.global.ColourHighlight = this.data[0]['ColourHighlight'];
      this.global.contacttype = this.data[0]['ContactType'];
      this.global.fullname = this.data[0]['Fullname'];
      this.global.logo = this.data[0]['Logo'];
      this.global.contactid = this.data[0]['ContactId'];
      this.global.agencyid = this.data[0]['AgencyId'];
      this.global.AllowApproval = this.data[0]['AllowApproval'];
      
      localStorage.setItem('agencyid', this.data[0]['AgencyId']);
      localStorage.setItem('ColourBanner1', this.data[0]['ColourBanner1']);
      localStorage.setItem('ColourBanner2', this.data[0]['ColourBanner2']);
      localStorage.setItem('ColourDeSelected', this.data[0]['ColourDeSelected']);
      localStorage.setItem('ColourFont', this.data[0]['ColourFont']);
      localStorage.setItem('ColourFont1', this.data[0]['ColourFont1']);
      localStorage.setItem('ColourFont2', this.data[0]['ColourFont2']);
      localStorage.setItem('ColourHighlight', this.data[0]['ColourHighlight']);
      localStorage.setItem('ContactType', this.data[0]['ContactType']);
      localStorage.setItem('Fullname', this.data[0]['Fullname']);
      localStorage.setItem('ContactId', this.data[0]['ContactId']);
      localStorage.setItem('AllowApproval', this.data[0]['AllowApproval']);


      if(this.global.contacttype == '1'){
        this.global.status = '0'; //to be completed
        localStorage.setItem('Status', this.global.status);

        this.global.defaultstatus = '0';
      }
      else if(this.global.contacttype == '0'){
        this.global.status = '1'; //awaiting approval
        localStorage.setItem('Status', this.global.status);
        
        this.global.defaultstatus = '1';
      }

      var auth = this.res.auth;
      localStorage.setItem('Auth', auth);

      //console.log(localStorage.getItem('Auth'));
      this.goToTimesheet(this.landingPage);
      

      }
      else {
        //console.log('no data');
      }


    },
    error =>
    {
      this.login_disable = false;
      this.presentToast();
    }
    );


  }

  forgotpassword () {
    this.navCtrl.push(ForgotPasswordPage, 
      { email: this.email.value
      , btnColor: this.btnColor
      , agencyid: this.agencyID });
  }
  goToTimesheet(landingpage: string){


    // window.location.href = "";

    var newURL = location.href.split("?")[0];
    window.history.pushState('object', document.title, newURL);

    if(landingpage == 'Timesheets' || landingpage == 'Timesheets3' || landingpage == 'timesheettype3'){


      this.navCtrl.setRoot(TimesheetlistPage);
      // this.navCtrl.setRoot('timesheetlist');
    }

  }


  presentToast() {
    let toast = this.toastCtrl.create({
      message: 'Login failure. Please try again.',
      duration: 3000,
      position: 'bottom'
    });

    toast.onDidDismiss(() => {
      //console.log('Dismissed toast');
    });

    toast.present();
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }



}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts